import { render, staticRenderFns } from "./AddMetadataModal.vue?vue&type=template&id=e9262a1a&scoped=true&"
import script from "./AddMetadataModal.vue?vue&type=script&lang=js&"
export * from "./AddMetadataModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMetadataModal.vue?vue&type=style&index=0&id=e9262a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9262a1a",
  null
  
)

export default component.exports